import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import classNames from 'classnames';
import { MFootnote } from '../MFootnote/MFootnote';
import styles from './o-footnotes.module.scss';
export const OFootnotes = ({ disableNumbering, footnotes, theme = 'dark' })=>!footnotes?.length ? null : /*#__PURE__*/ _jsx("div", {
        className: classNames(styles.footnotes, styles[theme]),
        children: footnotes?.map((footnote, index)=>/*#__PURE__*/ _createElement(MFootnote, {
                ...footnote,
                index: disableNumbering ? '-' : index + 1,
                key: footnote._uid,
                theme: theme
            }))
    });
const UWG_FOOTNOTE = {
    _uid: 'uwg-footnote',
    text: {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        text: '„Ökostrom“ bedeutet: In Höhe eures Verbrauchs wird Strom aus erneuerbaren Energien erzeugt und in das Stromnetz eingespeist. Der Nachweis erfolgt bilanziell zu 100 % über Herkunftsnachweise gemäß § 42 EnWG, die im Herkunftsnachweisregister des Umweltbundesamtes entwertet werden. Die tatsächliche Stromlieferung an eure Steckdose erfolgt physikalisch über das allgemeine Stromnetz, in dem sich Strom aus verschiedenen Quellen mischt (Strommix). Es kann dabei nicht sichergestellt werden, dass der konkrete Strom, den ihr verbraucht, tatsächlich aus erneuerbaren Energien stammt. Trotzdem wird durch den Einkauf und die Entwertung sogenannter Herkunftsnachweise sichergestellt, dass eine einmal aus erneuerbaren Energien erzeugte und in das Netz eingespeiste Strommenge auch nur einmal unter Kennzeichnung dieser Eigenschaft wieder entnommen werden kann. Die Zuordnung von Verbrauch und Herkunftsnachweisen sowie die Aufstellung der Herkunftsländer erfolgt im Rahmen der gesetzlichen Stromkennzeichnung. Diese findet ihr hier: ',
                        type: 'text'
                    },
                    {
                        text: 'Zusammensetzung unseres Strommix',
                        type: 'text',
                        marks: [
                            {
                                type: 'link',
                                attrs: {
                                    href: '/oekostrom/stromkennzeichnung',
                                    uuid: '3c82daf5-0eca-4f28-b361-cc738ea8dc13',
                                    anchor: null,
                                    target: '_self',
                                    linktype: 'story'
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
};
export const UWGFootnote = ()=>/*#__PURE__*/ _jsx("div", {
        className: classNames(styles.footnotes, styles.dark),
        children: /*#__PURE__*/ _jsx(MFootnote, {
            component: "m-footnote",
            ...UWG_FOOTNOTE,
            index: "*"
        })
    });

//# sourceMappingURL=OFootnotes.js.map